module.exports = __webpack_public_path__ + "static/media/carousel.a328b243.png";